var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "parent-element",
      style: `--pos-top: ${_vm.positionFromTop + "%"}; --height: ${
        _vm.height + "%"
      };`,
    },
    [
      _vm._v(" #"),
      _c("span", [
        _vm._v(
          _vm._s(_vm.booking.jobNumber) +
            ", " +
            _vm._s(_vm.booking.startTime.toFormat("HH:mm")) +
            " - " +
            _vm._s(_vm.booking.endTime.toFormat("HH:mm"))
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }